import SelectedEventTypeModal from './SelectedEventTypeModal';

export default SelectedEventTypeModal;
